export const Prestaciones = Object.freeze({
  PECATA: 1,
  POCATA: 2,
  POECATA: 7,
  PETECATA: 8,
  CAEX2: 10,
  CAOE2: 11,
  CAO2: 12,
  PCAR: 13,
  CATE2: 14,
  CAEX3: 15,
  CAOE3: 16,
  PCAR2: 17,
  CATE3: 18,
  CAEX4: 19,
  CAOE4: 20,
  CATE4: 21,
  PCAR3: 22,
  CAEX5: 24,
  CAOE5: 25,
  CATE5: 26,
  PCAR4: 27,
  PDIR: 23,
});

export const Estados = Object.freeze({
  // WEB.SOL_ESTADO
  INCOMPLETO: 0, //	Incompleto
  EN_ESTUDIO: 1, //	En estudio
  RES_FAVORABLE: 2, //	Resolución favorable provisional
  RES_DESFAVORABLE: 3, //	Resolución desfavorable provisional
  SUB_PENDIENTE: 4, //	Subsanación: Pendiente
  SUBSANADA: 5, //	Subsanada
  SUB_VALIDADA_OPERACIONES: 6, //	Subsanación: Validada por operaciones
  SUB_DOC_RECIBIDA: 7, //	Subsanación: Documentación recibida fehaciente
  CANCELADA: 12, //	Cancelada
  RENUNCIA_TOTAL: 13, //	Renuncia total
  RENUNCIA_PARCIAL: 14, //	Renuncia parcial
  PERDIDA_DERECHO: 15, //	Comunicación Pérdida del derecho
  PNDT_REVISION: 16, //	Pendiente revisión administrativa
  REVISADA: 17, //	Revisada
  RES_DESFAVORABLE_DEFINITVA: 18, //	Resolución desfavorable definitiva
  RES_FAVORABLE_DEFINITVA: 19, //	Resolución favorable definitiva
  RECTIFICACION_EXPEDIENTE: 20, //  Rectificación expediente
});

export const EstadoCampos = Object.freeze({
  // PRESTACIONES.AUD_ESTADO
  SIN_REVISAR: 1,
  EN_REVISION: 2,
  PDTE_SUBSANACION: 3,
  PDTE_VALIDAR_SUBSANACION: 4,
  PDTE_CONFIRMAR_VALIDACION: 5,
  CONFIRMADO: 6,
  RECHAZADO: 7,
});
//constantes de estado para expediente
export const textoEstado = Object.freeze({
  [Estados.INCOMPLETO]: 'estado.INCOMPLETO',
  [Estados.EN_ESTUDIO]: 'estado.EN_ESTUDIO',
  [Estados.RES_FAVORABLE]: 'estado.RES_FAVORABLE',
  [Estados.RES_DESFAVORABLE]: 'estado.RES_DESFAVORABLE',
  [Estados.SUB_PENDIENTE]: 'estado.SUB_PENDIENTE',
  [Estados.SUBSANADA]: 'estado.SUBSANADA',
  [Estados.SUB_VALIDADA_OPERACIONES]: 'estado.SUB_VALIDADA_OPERACIONES',
  [Estados.SUB_DOC_RECIBIDA]: 'estado.SUB_DOC_RECIBIDA',
  [Estados.CANCELADA]: 'estado.CANCELADA',
  [Estados.RENUNCIA_TOTAL]: 'estado.RENUNCIA_TOTAL',
  [Estados.RENUNCIA_PARCIAL]: 'estado.RENUNCIA_PARCIAL',
  [Estados.PERDIDA_DERECHO]: 'estado.PERDIDA_DERECHO',
  [Estados.PNDT_REVISION]: 'estado.PNDT_REVISION',
  [Estados.REVISADA]: 'estado.REVISADA',
});

export const colorEstado = Object.freeze({
  [Estados.INCOMPLETO]: 'bg-secondary',
  [Estados.EN_ESTUDIO]: 'bg-secondary',
  [Estados.RES_FAVORABLE]: 'bg-success',
  [Estados.RES_DESFAVORABLE]: 'bg-error',
  [Estados.SUB_PENDIENTE]: 'bg-secondary',
  [Estados.SUBSANADA]: 'bg-success',
  [Estados.SUB_VALIDADA_OPERACIONES]: 'bg-success',
  [Estados.SUB_DOC_RECIBIDA]: 'bg-secondary',
  [Estados.CANCELADA]: 'bg-error',
  [Estados.RENUNCIA_TOTAL]: 'bg-error',
  [Estados.RENUNCIA_PARCIAL]: 'bg-error',
  [Estados.PERDIDA_DERECHO]: 'bg-error',
  [Estados.PNDT_REVISION]: 'bg-secondary',
  [Estados.REVISADA]: 'bg-success',
});

export const colorEstadoRevision = Object.freeze({
  [EstadoCampos.SIN_REVISAR]: 'bg-lightShade',
  [EstadoCampos.EN_REVISION]: 'bg-lightAccent',
  [EstadoCampos.PDTE_SUBSANACION]: 'bg-secondary',
  [EstadoCampos.PDTE_VALIDAR_SUBSANACION]: 'bg-secondary',
  [EstadoCampos.PDTE_CONFIRMAR_VALIDACION]: 'bg-success',
  [EstadoCampos.CONFIRMADO]: 'bg-success',
  [EstadoCampos.RECHAZADO]: 'bg-error',
});

export const textoEstadoRevision = Object.freeze({
  [EstadoCampos.SIN_REVISAR]: 'auditoria.estado.sin_revisar',
  [EstadoCampos.EN_REVISION]: 'auditoria.estado.en_revision',
  [EstadoCampos.PDTE_SUBSANACION]: 'auditoria.estado.pdte_subsanar',
  [EstadoCampos.PDTE_VALIDAR_SUBSANACION]:
    'auditoria.estado.pdte_validar_subsanacion',
  [EstadoCampos.PDTE_CONFIRMAR_VALIDACION]:
    'auditoria.estado.pdte_confirmar_validacion',
  [EstadoCampos.CONFIRMADO]: 'auditoria.estado.confirmado',
  [EstadoCampos.RECHAZADO]: 'auditoria.estado.rechazado',
});

export const TIPO_CAMPO_UI = Object.freeze({
  BOOLEAN: 'Boolean',
  CNAE: 'CNAE',
  DATE: 'Date',
  DNI: 'DNI',
  HIJOS: 'Hijos',
  INCOMPATIBILIDAD: 'Incompatibilidad',
  NUMBER: 'Number',
  SELECT: 'Select',
  STRING: 'String',
  TITULAR_BANCO: 'TIT.BANCO',
});

export const CATEGORIA = Object.freeze({
  INCOMPATIBILIDADES: 'Incompatibilidades',
});

export const CAMPO_MAESTRO_ID = Object.freeze({
  PECATA_INCOMPATIBILIDADES: 19,
});
export const Global = Object.freeze({});

export const SOL_TIPO_DOCUMENTO = Object.freeze({
  PECATA_TRAMITE_AUDIENCIA_NOTIFICACION: 98,
  PECATA_TRAMITE_AUDIENCIA_SUBSANACION: 99,
  PECATA_SOLICITUD_IBAN: 902,
  PECATA_CONFIRMACION_IBAN: 903,
  PECATA_RESOLUCION_DEFINITIVA_NEGATIVA: 900,
  PECATA_RESOLUCION_DEFINITIVA_POSITIVA: 901,
  PECATA_NOTIFICACION_ALEGACION: 998,
  PECATA_SUBSANACION_ALEGACION: 999,
  PECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 904,
  PECATA_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 905,

  POECATA_TRAMITE_AUDIENCIA_NOTIFICACION: 7901,
  POECATA_TRAMITE_AUDIENCIA_SUBSANACION: 7902,
  POECATA_SOLICITUD_IBAN: 7951,
  POECATA_CONFIRMACION_IBAN: 7952,
  POECATA_NOTIFICACION_ALEGACION: 7911,
  POECATA_SUBSANACION_ALEGACION: 7912,
  POECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 7953,
  POECATA_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 7949,

  PETECATA_TRAMITE_AUDIENCIA_NOTIFICACION: 8901,
  PETECATA_TRAMITE_AUDIENCIA_SUBSANACION: 8902,
  PETECATA_SOLICITUD_IBAN: 8951,
  PETECATA_CONFIRMACION_IBAN: 8952,
  PETECATA_NOTIFICACION_ALEGACION: 8911,
  PETECATA_SUBSANACION_ALEGACION: 8912,
  PETECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 8953,
  PETECATA_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 8949,

  PECANE1_TRAMITE_AUDIENCIA_NOTIFICACION: 10901,
  PECANE1_TRAMITE_AUDIENCIA_SUBSANACION: 10902,
  PECANE1_SOLICITUD_IBAN: 10951,
  PECANE1_CONFIRMACION_IBAN: 10952,
  PECANE1_NOTIFICACION_ALEGACION: 10911,
  PECANE1_SUBSANACION_ALEGACION: 10912,
  PECANE1_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 10953,
  PECANE1_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 10949,

  PROPOECATA_TRAMITE_AUDIENCIA_NOTIFICACION: 11901,
  PROPOECATA_TRAMITE_AUDIENCIA_SUBSANACION: 11902,
  PROPOECATA_SOLICITUD_IBAN: 11951,
  PROPOECATA_CONFIRMACION_IBAN: 11952,
  PROPOECATA_NOTIFICACION_ALEGACION: 11911,
  PROPOECATA_SUBSANACION_ALEGACION: 11912,
  PROPOECATA_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 11953,
  PROPOECATA_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 11949,

  POECATA2_TRAMITE_AUDIENCIA_NOTIFICACION: 12901,
  POECATA2_TRAMITE_AUDIENCIA_SUBSANACION: 12902,
  POECATA2_SOLICITUD_IBAN: 12951,
  POECATA2_CONFIRMACION_IBAN: 12952,
  POECATA2_NOTIFICACION_ALEGACION: 12911,
  POECATA2_SUBSANACION_ALEGACION: 12912,
  POECATA2_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 12953,
  POECATA2_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 12949,

  PECANE2_TRAMITE_AUDIENCIA_NOTIFICACION: 13901,
  PECANE2_TRAMITE_AUDIENCIA_SUBSANACION: 13902,
  PECANE2_SOLICITUD_IBAN: 13951,
  PECANE2_CONFIRMACION_IBAN: 13952,
  PECANE2_NOTIFICACION_ALEGACION: 13911,
  PECANE2_SUBSANACION_ALEGACION: 13912,
  PECANE2_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 13953,
  PECANE2_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 13949,

  PECANE1_2_TRAMITE_AUDIENCIA_NOTIFICACION: 15901,
  PECANE1_2_TRAMITE_AUDIENCIA_SUBSANACION: 15902,
  PECANE1_2_SOLICITUD_IBAN: 15951,
  PECANE1_2_CONFIRMACION_IBAN: 15952,
  PECANE1_2_NOTIFICACION_ALEGACION: 15911,
  PECANE1_2_SUBSANACION_ALEGACION: 15912,
  PECANE1_2_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 15953,
  PECANE1_2_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 15949,

  POECATA3_TRAMITE_AUDIENCIA_NOTIFICACION: 16901,
  POECATA3_TRAMITE_AUDIENCIA_SUBSANACION: 16902,
  POECATA3_SOLICITUD_IBAN: 16951,
  POECATA3_CONFIRMACION_IBAN: 16952,
  POECATA3_NOTIFICACION_ALEGACION: 16911,
  POECATA3_SUBSANACION_ALEGACION: 16912,
  POECATA3_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 16953,
  POECATA3_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 16949,

  PECANE2_2_TRAMITE_AUDIENCIA_NOTIFICACION: 17901,
  PECANE2_2_TRAMITE_AUDIENCIA_SUBSANACION: 17902,
  PECANE2_2_SOLICITUD_IBAN: 17951,
  PECANE2_2_CONFIRMACION_IBAN: 17952,
  PECANE2_2_NOTIFICACION_ALEGACION: 17911,
  PECANE2_2_SUBSANACION_ALEGACION: 17912,
  PECANE2_2_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 17953,
  PECANE2_2_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 17949,

  PETECATA3_TRAMITE_AUDIENCIA_NOTIFICACION: 18901,
  PETECATA3_TRAMITE_AUDIENCIA_SUBSANACION: 18902,
  PETECATA3_SOLICITUD_IBAN: 18951,
  PETECATA3_CONFIRMACION_IBAN: 18952,
  PETECATA3_NOTIFICACION_ALEGACION: 18911,
  PETECATA3_SUBSANACION_ALEGACION: 18912,
  PETECATA3_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 18953,
  PETECATA3_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 18949,

  PECANE1_3_TRAMITE_AUDIENCIA_NOTIFICACION: 19901,
  PECANE1_3_TRAMITE_AUDIENCIA_SUBSANACION: 19902,
  PECANE1_3_SOLICITUD_IBAN: 19951,
  PECANE1_3_CONFIRMACION_IBAN: 19952,
  PECANE1_3_NOTIFICACION_ALEGACION: 19911,
  PECANE1_3_SUBSANACION_ALEGACION: 19912,
  PECANE1_3_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 19953,
  PECANE1_3_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 19949,

  POECATA4_TRAMITE_AUDIENCIA_NOTIFICACION: 20901,
  POECATA4_TRAMITE_AUDIENCIA_SUBSANACION: 20902,
  POECATA4_SOLICITUD_IBAN: 20951,
  POECATA4_CONFIRMACION_IBAN: 20952,
  POECATA4_NOTIFICACION_ALEGACION: 20911,
  POECATA4_SUBSANACION_ALEGACION: 20912,
  POECATA4_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 20953,
  POECATA4_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 20949,

  PETECATA4_TRAMITE_AUDIENCIA_NOTIFICACION: 21901,
  PETECATA4_TRAMITE_AUDIENCIA_SUBSANACION: 21902,
  PETECATA4_SOLICITUD_IBAN: 21951,
  PETECATA4_CONFIRMACION_IBAN: 21952,
  PETECATA4_NOTIFICACION_ALEGACION: 21911,
  PETECATA4_SUBSANACION_ALEGACION: 21912,
  PETECATA4_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 21953,
  PETECATA4_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 21949,

  PECANE2_3_TRAMITE_AUDIENCIA_NOTIFICACION: 22901,
  PECANE2_3_TRAMITE_AUDIENCIA_SUBSANACION: 22902,
  PECANE2_3_SOLICITUD_IBAN: 22951,
  PECANE2_3_CONFIRMACION_IBAN: 22952,
  PECANE2_3_NOTIFICACION_ALEGACION: 22911,
  PECANE2_3_SUBSANACION_ALEGACION: 22912,
  PECANE2_3_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 22953,
  PECANE2_3_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 22949,

  PECANE1_4_TRAMITE_AUDIENCIA_NOTIFICACION: 24901,
  PECANE1_4_TRAMITE_AUDIENCIA_SUBSANACION: 24902,
  PECANE1_4_SOLICITUD_IBAN: 24951,
  PECANE1_4_CONFIRMACION_IBAN: 24952,
  PECANE1_4_NOTIFICACION_ALEGACION: 24911,
  PECANE1_4_SUBSANACION_ALEGACION: 24912,
  PECANE1_4_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 24953,
  PECANE1_4_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 24949,

  POECATA5_TRAMITE_AUDIENCIA_NOTIFICACION: 25901,
  POECATA5_TRAMITE_AUDIENCIA_SUBSANACION: 25902,
  POECATA5_SOLICITUD_IBAN: 25951,
  POECATA5_CONFIRMACION_IBAN: 25952,
  POECATA5_NOTIFICACION_ALEGACION: 25911,
  POECATA5_SUBSANACION_ALEGACION: 25912,
  POECATA5_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 25953,
  POECATA5_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 25949,

  PETECATA5_TRAMITE_AUDIENCIA_NOTIFICACION: 26901,
  PETECATA5_TRAMITE_AUDIENCIA_SUBSANACION: 26902,
  PETECATA5_SOLICITUD_IBAN: 26951,
  PETECATA5_CONFIRMACION_IBAN: 26952,
  PETECATA5_NOTIFICACION_ALEGACION: 26911,
  PETECATA5_SUBSANACION_ALEGACION: 26912,
  PETECATA5_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 26953,
  PETECATA5_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 26949,

  PECANE2_4_TRAMITE_AUDIENCIA_NOTIFICACION: 27901,
  PECANE2_4_TRAMITE_AUDIENCIA_SUBSANACION: 27902,
  PECANE2_4_SOLICITUD_IBAN: 27951,
  PECANE2_4_CONFIRMACION_IBAN: 27952,
  PECANE2_4_NOTIFICACION_ALEGACION: 27911,
  PECANE2_4_SUBSANACION_ALEGACION: 27912,
  PECANE2_4_RESOLUCION_DEFINITIVA_NEGATIVA_FINAL: 27953,
  PECANE2_4_DEFINITIVA_FAVORABLE_DIFERENCIAS_RECLAMAR: 27949,

  CATA_DANA_RESOLUCION_FAVORABLE_PROVISIONAL: 50114,
  CATA_DANA_RESOLUCION_DESFAVORABLE_PROVISIONAL: 50116,
});

// (tiposAlegacion, tiposTramiteAudiencia, tiposCircuitoAbono). Útil para el control de redireccion al ir a la pantalla anterior desde DeclaracionMain
export const tiposAlegacion = [
  SOL_TIPO_DOCUMENTO.PECATA_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.POECATA_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PETECATA_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PROPOECATA_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE1_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE2_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.POECATA2_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE1_2_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.POECATA3_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE2_2_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PETECATA3_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE1_3_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.POECATA4_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PETECATA4_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE2_3_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE1_4_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.POECATA5_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PETECATA5_NOTIFICACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE2_4_NOTIFICACION_ALEGACION,

  SOL_TIPO_DOCUMENTO.PECATA_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.POECATA_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PETECATA_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PROPOECATA_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE1_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE2_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.POECATA2_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE1_2_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.POECATA3_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE2_2_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PETECATA3_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE1_3_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.POECATA4_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PETECATA4_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE2_3_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE1_4_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.POECATA5_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PETECATA5_SUBSANACION_ALEGACION,
  SOL_TIPO_DOCUMENTO.PECANE2_4_SUBSANACION_ALEGACION,
];
export const tiposTramiteAudiencia = [
  SOL_TIPO_DOCUMENTO.PECATA_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.POECATA_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.PETECATA_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.PROPOECATA_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.PECANE1_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.PECANE2_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.POECATA2_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.PECANE1_2_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.POECATA3_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.PECANE2_2_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.PETECATA3_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.PECANE1_3_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.POECATA4_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.PETECATA4_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.PECANE2_3_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.PECANE1_4_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.POECATA5_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.PETECATA5_TRAMITE_AUDIENCIA_NOTIFICACION,
  SOL_TIPO_DOCUMENTO.PECANE2_4_TRAMITE_AUDIENCIA_NOTIFICACION,

  SOL_TIPO_DOCUMENTO.PECATA_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.POECATA_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.PETECATA_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.PROPOECATA_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.PECANE1_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.PECANE2_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.POECATA2_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.PECANE1_2_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.POECATA3_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.PECANE2_2_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.PETECATA3_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.PECANE1_3_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.POECATA4_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.PETECATA4_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.PECANE2_3_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.PECANE1_4_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.POECATA5_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.PETECATA5_TRAMITE_AUDIENCIA_SUBSANACION,
  SOL_TIPO_DOCUMENTO.PECANE2_4_TRAMITE_AUDIENCIA_SUBSANACION,
];
export const tiposCircuitoAbono = [
  SOL_TIPO_DOCUMENTO.PECATA_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.POECATA_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.PETECATA_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.PROPOECATA_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE1_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE2_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.POECATA2_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE1_2_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.POECATA3_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE2_2_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.PETECATA3_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE1_3_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.POECATA4_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.PETECATA4_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE2_3_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE1_4_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.POECATA5_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.PETECATA5_SOLICITUD_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE2_4_SOLICITUD_IBAN,

  SOL_TIPO_DOCUMENTO.PECATA_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.POECATA_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.PETECATA_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.PROPOECATA_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE1_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE2_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.POECATA2_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE1_2_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.POECATA3_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE2_2_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.PETECATA3_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE1_3_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.POECATA4_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.PETECATA4_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE2_3_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE1_4_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.POECATA5_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.PETECATA5_CONFIRMACION_IBAN,
  SOL_TIPO_DOCUMENTO.PECANE2_4_CONFIRMACION_IBAN,
];
